module.exports = __webpack_public_path__ + "img/accessory_pants_10.0e60c598.svg";